module.exports = __webpack_public_path__ + "img/Xgrow-3-pt.ee676830.png";